/** IntersectionObserverによるスクロールフェードイン */

const TARGET_SELECTOR = '[class*="js-fadeIn"]'; // js-fadeIn / js-fadeInUp / js-fadeInUp-30 / js-fadeInUp-40 を対象
const STAGGER_SELECTOR = ".js-stagger"; // 配下のjs-fadeIn系要素を時間差で表示するコンテナ
const VISIBLE_CLASS = "-inview";
const DEFAULT_MARGIN = 15; // 基準値未指定の場合はビューポート下端から15%
const STAGGER_STEP = 100; // 時間差表示の間隔（ms）

/**
 * 要素/コンテナ自身の高さに対する可視率(threshold)だと、対象の高さによって
 * 発火に必要なスクロール量が大きくばらつく（背の高いリストほど遅れて見える）ため、
 * ビューポート基準のrootMarginで発火位置を揃える。
 * クラス名から出現位置(ビューポート下端からの%)を取得する
 * 例: js-fadeInUp-30 → 下端から30% / js-stagger-40 → 下端から40% / それ以外 → DEFAULT_MARGIN
 * @param {HTMLElement} el
 * @param {string} prefix - 判定対象のクラス名プレフィックス
 * @returns {string} IntersectionObserverのrootMarginに渡す値
 */
const getRootMargin = (el, prefix) => {
  const matched = el.className.match(new RegExp(`${prefix}-(\\d+)`));
  const margin = matched ? Number(matched[1]) : DEFAULT_MARGIN;
  return `0px 0px -${margin}% 0px`;
};

/**
 * js-stagger配下のjs-fadeIn系要素を、コンテナの交差を起点に時間差で表示する
 */
const initStagger = () => {
  const containers = document.querySelectorAll(STAGGER_SELECTOR);

  containers.forEach((container) => {
    const children = container.querySelectorAll(TARGET_SELECTOR);
    if (!children.length) return;

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          children.forEach((child, index) => {
            setTimeout(() => {
              child.classList.add(VISIBLE_CLASS);
            }, index * STAGGER_STEP);
          });
          obs.unobserve(entry.target);
        });
      },
      { rootMargin: getRootMargin(container, "js-stagger") },
    );
    observer.observe(container);
  });
};

/**
 * js-fadeIn系要素を個別に監視し、交差したらフェードインする（js-stagger配下は対象外）
 */
const initFadeIn = () => {
  const targets = document.querySelectorAll(TARGET_SELECTOR);

  targets.forEach((target) => {
    if (target.closest(STAGGER_SELECTOR)) return;

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add(VISIBLE_CLASS);
          obs.unobserve(entry.target);
        });
      },
      { rootMargin: getRootMargin(target, "js-fadeInUp") },
    );
    observer.observe(target);
  });
};

/**
 * index.js の DOMContentLoaded 内で呼ばれる前提。
 * load（画像・外部タグの読み込み完了）を待つと初回表示のフェードインが1.5秒以上遅れるため即時に初期化する。
 * 画像読み込み等によるレイアウト変化には IntersectionObserver が追従する。
 */
const fadeIn = () => {
  initStagger();
  initFadeIn();
};

export { fadeIn };
